import { ServerError } from "breeze-client";

export interface BreezeEntityError {
    propertyName?: string;
    errorMessage?: string;
    [key: string]: unknown;
}

export interface SaveError extends ServerError {
    entityErrors: BreezeEntityError[];
}

export function isBreezeServerError(error: unknown): error is ServerError {
    return (
        error != null &&
        typeof error === "object" &&
        "status" in error &&
        typeof (error as Record<string, unknown>).status === "number"
    );
}

export function isBreezeSaveError(error: unknown): error is SaveError {
    return (
        error != null &&
        typeof error === "object" &&
        "entityErrors" in error &&
        Array.isArray((error as Record<string, unknown>).entityErrors)
    );
}
